var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Wz=require("ttag");module.exports=$CLJS.Wz;